export default __webpack_public_path__ + "static/media/point-blue.b97eca42.svg";